import { useMemo } from 'react'
import { GridOptions } from 'ag-grid-community'
import { ApplicationFunctionPermissionRow } from '../types'
import { PermissionPolicyOption } from '../../../../domain/value-object/PermissionPolicy'
import { useColumnDefs } from './columnDefs'
import {
  columnTypes,
  frameworkComponents,
} from '../../../containers/commons/AgGrid'
import { DEFAULT_COLUMN_DEF } from '../../../page-properties/bulksheet-properties'

type UsePermissionPolicyGridProps = {
  permissionPolicyOptions: PermissionPolicyOption[]
}

/**
 * 権限ポリシー確認画面のグリッド設定を生成
 */
export const usePermissionPolicyGridOptions = ({
  permissionPolicyOptions,
}: UsePermissionPolicyGridProps): GridOptions<ApplicationFunctionPermissionRow> => {
  const columnDefs = useColumnDefs({
    permissionPolicyOptions,
  })

  const gridOptions: GridOptions<ApplicationFunctionPermissionRow> = useMemo(
    () => ({
      groupHeaderHeight: 25,
      headerHeight: 45,
      floatingFiltersHeight: 25,
      rowHeight: 32,
      context: {},
      suppressLastEmptyLineOnPaste: true,

      // Column
      columnTypes: columnTypes(),
      components: frameworkComponents,
      defaultColDef: DEFAULT_COLUMN_DEF,
      columnDefs,

      // 読み取り専用画面なので選択関連の設定
      rowSelection: 'single',
      suppressRowClickSelection: true,
      enableCellTextSelection: true,
      ensureDomOrder: true,
    }),
    [columnDefs]
  )

  return gridOptions
}
